'use client'

import {
  addToCart,
  generateLead,
  initiateCheckout,
  purchase,
  shareInfo,
  viewItem,
  funnelProgress,
} from '@/lib/gtm/client'
import { useEffect } from 'react'

type GTMEventType =
  | 'view_item'
  | 'share_info'
  | 'generate_lead'
  | 'add_to_cart'
  | 'initiate_checkout'
  | 'purchase'
  | 'funnel_progress'

export interface GTMTrackerProps {
  event: GTMEventType
  data: any
}

export function GtmTrackerClient({ event, data }: GTMTrackerProps) {
  useEffect(() => {
    switch (event) {
      case 'view_item':
        viewItem(data)
        break
      case 'share_info':
        shareInfo(data)
        break
      case 'generate_lead':
        generateLead(data)
        break
      case 'add_to_cart':
        addToCart(data)
        break
      case 'initiate_checkout':
        initiateCheckout(data)
        break
      case 'purchase':
        purchase(data)
        break
      case 'funnel_progress':
        funnelProgress(data)
        break
    }
  }, [event, data])

  return null
}

export default GtmTrackerClient
